import * as z from "zod"
import { AgentExecutionStatus } from "@prisma/client"

// Helper schema for JSON fields
type Literal = boolean | number | string
type Json = Literal | { [key: string]: Json } | Json[]
const literalSchema = z.union([z.string(), z.number(), z.boolean()])
const jsonSchema: z.ZodSchema<Json> = z.lazy(() => z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)]))

export const AgentExecutionModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  agent_name: z.string(),
  agent_version: z.string(),
  provider: z.string(),
  model: z.string(),
  /**
   * [TenantId]
   */
  tenant_id: z.string().nullish(),
  account_id: z.number().int().nullish(),
  user_id: z.number().int().nullish(),
  source: z.string(),
  request_id: z.number().int().nullish(),
  input: jsonSchema,
  output: jsonSchema,
  raw_completion: jsonSchema,
  status: z.nativeEnum(AgentExecutionStatus),
  validation_messages: z.string().array(),
  error: jsonSchema,
  prompt_tokens: z.number().int().nullish(),
  completion_tokens: z.number().int().nullish(),
  cost_in_cents: z.number().nullish(),
  latency_ms: z.number().int().nullish(),
  is_human_corrected: z.boolean(),
  correction: jsonSchema,
  reviewed_by_id: z.number().int().nullish(),
  reviewed_at: z.date().nullish(),
})
